import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { PageCarousel } from './components/PageCarousel';
import { SamplePlan } from './components/SamplePlan';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
import { volumePages } from './data/volumePages';
// Review sections render only once data/testimonials.ts holds real buyer reviews.
// "Look inside" shows real page images when data/volumePages.ts has them; otherwise a Class Plan replica.

export function App() {
  return <div className="min-h-screen w-full bg-cloud text-ink font-sans selection:bg-amber selection:text-ink" data-id="element-0" data-mp="3relwynhtxubv">
      <MetaPixel data-id="element-1" data-mp="2zl3cxocsjc6w" />
      <main data-id="element-2" data-mp="2zlli5ahfl0qy">
        <Hero data-id="element-3" data-mp="2zm4zaoz9bl3x" />
        <SocialProofBar data-id="element-4" data-mp="2zmo4r67q0h12" />
        <PainGrid data-id="element-5" data-mp="2zn6cp03qwjot" />
        <ProductReveal data-id="element-6" data-mp="33morde4z3yj7" />
        <Tomes data-id="element-7" data-mp="33lwzadal4ixo" />
        {volumePages.length > 0 ? <PageCarousel data-id="element-8" data-mp="33myix65o2dr0" /> : <SamplePlan data-id="element-9" data-mp="33oi152avuyvf" />}
        <Bonuses data-id="element-10" data-mp="38l8idsyfc0if" />
        <ValueStack data-id="element-11" data-mp="38kqd66tsabyd" />
        <Urgency data-id="element-12" data-mp="38k6v8q44vnkc" />
        <Pricing data-id="element-13" data-mp="38nuqbtp88i16" />
        <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="white" data-id="element-14" data-mp="3dkuws5pznmst" />
        <Guarantee data-id="element-15" data-mp="nvj3jfxq0epq" />
        <Faq data-id="element-16" data-mp="nw2e2bl1k0tq" />
        <Testimonials testimonials={moreTestimonials} title="Works alongside your studio’s program" subtitle="Instructors use it to turn the skills they already teach into a full class." background="cream" data-id="element-17" data-mp="nuhhkgf627t8" />
        <CostOfInaction data-id="element-18" data-mp="3uct43lu76r1j" />
        <Close data-id="element-19" data-mp="3udazkg91d18e" />
      </main>
      <Footer data-id="element-20" data-mp="3ubzw6hji5vht" />
    </div>;
}